import type { ErrorEvent } from '@sentry/react';

const OWN_BUNDLE_URL = /^https?:\/\/[^/]+\/packs\//;

// スタックに Webpacker のバンドル（/packs/）のフレームが 1 つも無い例外は送らない。
export const dropErrorOutsideOwnBundle = (
  event: ErrorEvent
): ErrorEvent | null => {
  const exceptions = event.exception?.values;
  if (!exceptions?.length) return event;

  const fromOwnBundle = exceptions.some((exception) =>
    exception.stacktrace?.frames?.some(
      (frame) =>
        frame.filename !== undefined && OWN_BUNDLE_URL.test(frame.filename)
    )
  );
  return fromOwnBundle ? event : null;
};
